import { render, staticRenderFns } from "./ModalDialogVisualizacaoImg.vue?vue&type=template&id=585a28a5&scoped=true&"
import script from "./ModalDialogVisualizacaoImg.vue?vue&type=script&lang=js&"
export * from "./ModalDialogVisualizacaoImg.vue?vue&type=script&lang=js&"
import style0 from "./ModalDialogVisualizacaoImg.vue?vue&type=style&index=0&id=585a28a5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585a28a5",
  null
  
)

export default component.exports